import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,Box} from "@mui/material";
import CustomCancelButton from "./CustomCancelButton";
import CustomButton from "./CustomButton";
import Button from '@mui/material/Button';

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LK_AlertIcon from "../../images/LK_AlertIcon";

export default function CustomDialogBox({ dialogTitle, dialogText, openDialog, handleCloseDialog, handleConfirmDialog, confirmText, cancelText, type, align, children, maxWidth }) {
    const colortypemap=[["Info","#005C8E"],["Success","#00943d"],["Warning","#ffd000"],["Error","#dc272d"]];
    const [colortype,setColortype]=useState("#005C8E");
    const theme = useSelector((state) => state.themedata.theme);

    useEffect(() => {
    if (type) {
        let color = colortypemap.filter((val) => type === val[0]);
        if (color.length > 0) {
            setColortype(color[0][1]);
        } else {
            setColortype(type); 
        }
    }}, [type]);
    return(
        <Dialog
            open={openDialog}
            // onClose={handleCloseDialog}
            BackdropProps={{
                sx:{
                    backgroundColor: (theme == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                }
            }}
            sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"36px", borderTopRightRadius:"36px",  backgroundColor:(theme == 'light')?"#FFFFFF":"#19191B",alignContent:"center", maxWidth: maxWidth || 'sm', width: maxWidth ? '100%' : 'auto' } }}
        >
            <DialogTitle  sx={{color:colortype=="#ffd000"?"#000000":"#FFFFFF", backgroundColor:colortype,margin:"4px", borderRadius:"40px",fontFamily:'Roboto',alignContent:"center",justifyContent:"center",textAlign:'center','&.MuiDialogTitle-root':{padding:'8px'}}}>
                <Box sx={{display:'flex',flexDirection:"column", alignContent:"center",justifyContent:"center",textAlign:'center',alignItems:'center',padding:"0px 12px "}}>
                <LK_AlertIcon color={colortype} width={"20px"} height={"20px"}/>
                {dialogTitle}
                </Box>
            </DialogTitle>
            <DialogContent
                sx={{
                    alignContent:"center",
                    padding:'24px',
                    color:(theme == 'light')?"#19191B":"#FFFFFF",
                    '&.MuiDialogContent-root':{padding:'16px 32px'},
                    '& .MuiTypography-root': {
                        color: (theme == 'light') ? "#19191B" : "#FFFFFF",
                    }
                }}
            >
                {children ? (
                    <Box sx={{ width: '100%', color: (theme == 'light') ? "#19191B" : "#FFFFFF" }}>{children}</Box>
                ) : (
                    <DialogContentText style={{alignContent:"center",textAlign:align? align: 'left'}} sx={{color:(theme == 'light')?"#19191B":"#FFFFFF",}}>
                       {dialogText}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions sx={{justifyContent:'center'}}> 

               {confirmText && <CustomButton onClick={handleConfirmDialog} buttonText={confirmText} width={100}></CustomButton>} 
               {cancelText && <CustomCancelButton onClick={handleCloseDialog} buttonText={cancelText} width={100}></CustomCancelButton>} 
            </DialogActions>
        </Dialog>
    );
}